export const REGION_LOAD_REQUEST = 'REGION_LOAD_REQUEST';
export const REGION_LOAD_SUCCESS = 'REGION_LOAD_SUCCESS';
export const REGION_LOAD_FAILURE = 'REGION_LOAD_FAILURE';
